import { Link, useLocation } from "react-router-dom";
import { WE_PEDIDOS_AVAILABLE } from "../../services/local/wePedidosAvailability";
import { WE_PEDIDOS_LOGO_URL } from "../../services/local/institutionalBranding";
import "../../styles/WePedidosUnavailable.css";

export default function WePedidosAvailabilityGate({ children, deliveryEntryOnly = false }) {
  const { search } = useLocation();
  const isWeEntry = new URLSearchParams(search).get("entry") === "we_pedidos";
  if (WE_PEDIDOS_AVAILABLE || (deliveryEntryOnly && !isWeEntry)) return children;

  return (
    <main className="we-unavailable">
      <section className="we-unavailable__card" aria-labelledby="we-unavailable-title">
        <img src={WE_PEDIDOS_LOGO_URL} alt="We! pedidos" />
        <span className="we-unavailable__badge">Proximamente</span>
        <h1 id="we-unavailable-title">Todavia no estamos disponibles</h1>
        <p>Estamos preparando We! pedidos. Por ahora no se pueden realizar nuevos pedidos desde esta plataforma.</p>
        <Link to="/we-pedidos/pedidos">Consultar mis pedidos existentes</Link>
      </section>
    </main>
  );
}
